<template>
  <div>
    <v-card color="#F6F8FC" flat class="px-5">
      <v-form v-model="valid" class="py-8">
        <v-card style="width: 8.7vw; padding: 1%" flat color="transparent">
          <practitionerimageuploader-component />
          <!-- <VueDropify ></VueDropify> -->
          <!-- <vue-dropzone :options="dropzoneOptions" :useCustomSlot="true">
            <svg style="width:8.1vw"
              viewBox="0 0 119 119"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="0.5"
                width="118"
                height="118"
                rx="15.5"
                fill="white"
                fill-opacity="0.75"
                stroke="#EDF0F6"
                stroke-dasharray="4 4"
              />
              <path
                d="M16.578 88.3028C15.906 88.3028 15.2947 88.1721 14.744 87.9108C14.2027 87.6401 13.7687 87.2248 13.442 86.6648C13.1153 86.1048 12.952 85.3908 12.952 84.5228V78.3348H14.128V84.5368C14.128 85.4888 14.3567 86.1794 14.814 86.6088C15.2713 87.0381 15.8687 87.2528 16.606 87.2528C17.3433 87.2528 17.936 87.0381 18.384 86.6088C18.832 86.1794 19.056 85.4888 19.056 84.5368V78.3348H20.232V84.5228C20.232 85.3908 20.0687 86.1048 19.742 86.6648C19.4153 87.2248 18.9767 87.6401 18.426 87.9108C17.8753 88.1721 17.2593 88.3028 16.578 88.3028ZM22.1535 91.2148V81.1908H23.2175L23.3295 82.3388C23.5535 82.0028 23.8708 81.6994 24.2815 81.4288C24.7015 81.1581 25.2335 81.0228 25.8775 81.0228C26.5682 81.0228 27.1702 81.1814 27.6835 81.4988C28.1968 81.8161 28.5935 82.2501 28.8735 82.8008C29.1628 83.3514 29.3075 83.9768 29.3075 84.6768C29.3075 85.3768 29.1628 86.0021 28.8735 86.5528C28.5935 87.0941 28.1922 87.5234 27.6695 87.8408C27.1562 88.1488 26.5542 88.3028 25.8635 88.3028C25.2942 88.3028 24.7855 88.1861 24.3375 87.9528C23.8988 87.7194 23.5628 87.3928 23.3295 86.9728V91.2148H22.1535ZM25.7375 87.2808C26.2042 87.2808 26.6148 87.1734 26.9695 86.9588C27.3242 86.7348 27.6042 86.4268 27.8095 86.0348C28.0148 85.6428 28.1175 85.1854 28.1175 84.6628C28.1175 84.1401 28.0148 83.6828 27.8095 83.2908C27.6042 82.8988 27.3242 82.5954 26.9695 82.3808C26.6148 82.1568 26.2042 82.0448 25.7375 82.0448C25.2708 82.0448 24.8602 82.1568 24.5055 82.3808C24.1508 82.5954 23.8708 82.8988 23.6655 83.2908C23.4602 83.6828 23.3575 84.1401 23.3575 84.6628C23.3575 85.1854 23.4602 85.6428 23.6655 86.0348C23.8708 86.4268 24.1508 86.7348 24.5055 86.9588C24.8602 87.1734 25.2708 87.2808 25.7375 87.2808ZM30.9445 88.1348V78.0548H32.1205V88.1348H30.9445ZM37.212 88.3028C36.5587 88.3028 35.9707 88.1534 35.448 87.8548C34.9254 87.5561 34.51 87.1361 34.202 86.5948C33.9034 86.0441 33.754 85.4001 33.754 84.6628C33.754 83.9254 33.908 83.2861 34.216 82.7448C34.524 82.1941 34.9394 81.7694 35.462 81.4708C35.994 81.1721 36.5867 81.0228 37.24 81.0228C37.8934 81.0228 38.4814 81.1721 39.004 81.4708C39.5267 81.7694 39.9374 82.1941 40.236 82.7448C40.544 83.2861 40.698 83.9254 40.698 84.6628C40.698 85.4001 40.544 86.0441 40.236 86.5948C39.928 87.1361 39.508 87.5561 38.976 87.8548C38.4534 88.1534 37.8654 88.3028 37.212 88.3028ZM37.212 87.2948C37.6134 87.2948 37.9867 87.1968 38.332 87.0008C38.6774 86.8048 38.9574 86.5108 39.172 86.1188C39.3867 85.7268 39.494 85.2414 39.494 84.6628C39.494 84.0841 39.3867 83.5988 39.172 83.2068C38.9667 82.8148 38.6914 82.5208 38.346 82.3248C38.0007 82.1288 37.632 82.0308 37.24 82.0308C36.8387 82.0308 36.4654 82.1288 36.12 82.3248C35.7747 82.5208 35.4947 82.8148 35.28 83.2068C35.0654 83.5988 34.958 84.0841 34.958 84.6628C34.958 85.2414 35.0654 85.7268 35.28 86.1188C35.4947 86.5108 35.77 86.8048 36.106 87.0008C36.4514 87.1968 36.82 87.2948 37.212 87.2948ZM44.6432 88.3028C44.0645 88.3028 43.5839 88.2048 43.2012 88.0088C42.8185 87.8128 42.5339 87.5514 42.3472 87.2248C42.1605 86.8981 42.0672 86.5434 42.0672 86.1608C42.0672 85.4514 42.3379 84.9054 42.8792 84.5228C43.4205 84.1401 44.1579 83.9488 45.0912 83.9488H46.9672V83.8648C46.9672 83.2581 46.8085 82.8008 46.4912 82.4928C46.1739 82.1754 45.7492 82.0168 45.2172 82.0168C44.7599 82.0168 44.3632 82.1334 44.0272 82.3668C43.7005 82.5908 43.4952 82.9221 43.4112 83.3608H42.2072C42.2539 82.8568 42.4219 82.4321 42.7112 82.0868C43.0099 81.7414 43.3785 81.4801 43.8172 81.3028C44.2559 81.1161 44.7225 81.0228 45.2172 81.0228C46.1879 81.0228 46.9159 81.2841 47.4012 81.8068C47.8959 82.3201 48.1432 83.0061 48.1432 83.8648V88.1348H47.0932L47.0232 86.8888C46.8272 87.2808 46.5379 87.6168 46.1552 87.8968C45.7819 88.1674 45.2779 88.3028 44.6432 88.3028ZM44.8252 87.3088C45.2732 87.3088 45.6559 87.1921 45.9732 86.9588C46.2999 86.7254 46.5472 86.4221 46.7152 86.0488C46.8832 85.6754 46.9672 85.2834 46.9672 84.8728V84.8588H45.1892C44.4985 84.8588 44.0085 84.9801 43.7192 85.2228C43.4392 85.4561 43.2992 85.7501 43.2992 86.1048C43.2992 86.4688 43.4299 86.7628 43.6912 86.9868C43.9619 87.2014 44.3399 87.3088 44.8252 87.3088ZM53.0574 88.3028C52.3667 88.3028 51.7601 88.1441 51.2374 87.8268C50.7241 87.5094 50.3227 87.0754 50.0334 86.5248C49.7534 85.9741 49.6134 85.3488 49.6134 84.6488C49.6134 83.9488 49.7581 83.3281 50.0474 82.7868C50.3367 82.2361 50.7381 81.8068 51.2514 81.4988C51.7647 81.1814 52.3714 81.0228 53.0714 81.0228C53.6407 81.0228 54.1447 81.1394 54.5834 81.3728C55.0221 81.6061 55.3627 81.9328 55.6054 82.3528V78.0548H56.7814V88.1348H55.7174L55.6054 86.9868C55.3814 87.3228 55.0594 87.6261 54.6394 87.8968C54.2194 88.1674 53.6921 88.3028 53.0574 88.3028ZM53.1834 87.2808C53.6501 87.2808 54.0607 87.1734 54.4154 86.9588C54.7794 86.7348 55.0594 86.4268 55.2554 86.0348C55.4607 85.6428 55.5634 85.1854 55.5634 84.6628C55.5634 84.1401 55.4607 83.6828 55.2554 83.2908C55.0594 82.8988 54.7794 82.5954 54.4154 82.3808C54.0607 82.1568 53.6501 82.0448 53.1834 82.0448C52.7261 82.0448 52.3154 82.1568 51.9514 82.3808C51.5967 82.5954 51.3167 82.8988 51.1114 83.2908C50.9154 83.6828 50.8174 84.1401 50.8174 84.6628C50.8174 85.1854 50.9154 85.6428 51.1114 86.0348C51.3167 86.4268 51.5967 86.7348 51.9514 86.9588C52.3154 87.1734 52.7261 87.2808 53.1834 87.2808ZM63.1175 79.6508C62.8842 79.6508 62.6882 79.5761 62.5295 79.4268C62.3802 79.2681 62.3055 79.0721 62.3055 78.8388C62.3055 78.6148 62.3802 78.4281 62.5295 78.2788C62.6882 78.1294 62.8842 78.0548 63.1175 78.0548C63.3415 78.0548 63.5328 78.1294 63.6915 78.2788C63.8502 78.4281 63.9295 78.6148 63.9295 78.8388C63.9295 79.0721 63.8502 79.2681 63.6915 79.4268C63.5328 79.5761 63.3415 79.6508 63.1175 79.6508ZM62.5295 88.1348V81.1908H63.7055V88.1348H62.5295ZM65.7531 88.1348V81.1908H66.8171L66.9011 82.1988C67.1251 81.8254 67.4238 81.5361 67.7971 81.3308C68.1704 81.1254 68.5904 81.0228 69.0571 81.0228C69.6078 81.0228 70.0791 81.1348 70.4711 81.3588C70.8724 81.5828 71.1804 81.9234 71.3951 82.3808C71.6378 81.9608 71.9691 81.6294 72.3891 81.3868C72.8184 81.1441 73.2804 81.0228 73.7751 81.0228C74.6058 81.0228 75.2684 81.2748 75.7631 81.7788C76.2578 82.2734 76.5051 83.0388 76.5051 84.0748V88.1348H75.3431V84.2008C75.3431 83.4821 75.1984 82.9408 74.9091 82.5768C74.6198 82.2128 74.2044 82.0308 73.6631 82.0308C73.1031 82.0308 72.6364 82.2501 72.2631 82.6888C71.8991 83.1181 71.7171 83.7341 71.7171 84.5368V88.1348H70.5411V84.2008C70.5411 83.4821 70.3964 82.9408 70.1071 82.5768C69.8178 82.2128 69.4024 82.0308 68.8611 82.0308C68.3104 82.0308 67.8484 82.2501 67.4751 82.6888C67.1111 83.1181 66.9291 83.7341 66.9291 84.5368V88.1348H65.7531ZM80.5865 88.3028C80.0079 88.3028 79.5272 88.2048 79.1445 88.0088C78.7619 87.8128 78.4772 87.5514 78.2905 87.2248C78.1039 86.8981 78.0105 86.5434 78.0105 86.1608C78.0105 85.4514 78.2812 84.9054 78.8225 84.5228C79.3639 84.1401 80.1012 83.9488 81.0345 83.9488H82.9105V83.8648C82.9105 83.2581 82.7519 82.8008 82.4345 82.4928C82.1172 82.1754 81.6925 82.0168 81.1605 82.0168C80.7032 82.0168 80.3065 82.1334 79.9705 82.3668C79.6439 82.5908 79.4385 82.9221 79.3545 83.3608H78.1505C78.1972 82.8568 78.3652 82.4321 78.6545 82.0868C78.9532 81.7414 79.3219 81.4801 79.7605 81.3028C80.1992 81.1161 80.6659 81.0228 81.1605 81.0228C82.1312 81.0228 82.8592 81.2841 83.3445 81.8068C83.8392 82.3201 84.0865 83.0061 84.0865 83.8648V88.1348H83.0365L82.9665 86.8888C82.7705 87.2808 82.4812 87.6168 82.0985 87.8968C81.7252 88.1674 81.2212 88.3028 80.5865 88.3028ZM80.7685 87.3088C81.2165 87.3088 81.5992 87.1921 81.9165 86.9588C82.2432 86.7254 82.4905 86.4221 82.6585 86.0488C82.8265 85.6754 82.9105 85.2834 82.9105 84.8728V84.8588H81.1325C80.4419 84.8588 79.9519 84.9801 79.6625 85.2228C79.3825 85.4561 79.2425 85.7501 79.2425 86.1048C79.2425 86.4688 79.3732 86.7628 79.6345 86.9868C79.9052 87.2014 80.2832 87.3088 80.7685 87.3088ZM88.5948 85.9508C88.2028 85.9508 87.8434 85.8994 87.5168 85.7968L86.8168 86.4548C86.9194 86.5294 87.0454 86.5948 87.1948 86.6508C87.3534 86.6974 87.5774 86.7441 87.8668 86.7908C88.1561 86.8281 88.5621 86.8701 89.0848 86.9168C90.0181 86.9821 90.6854 87.1968 91.0868 87.5608C91.4881 87.9248 91.6888 88.4008 91.6888 88.9888C91.6888 89.3901 91.5768 89.7728 91.3528 90.1368C91.1381 90.5008 90.8021 90.7994 90.3448 91.0328C89.8968 91.2661 89.3181 91.3828 88.6088 91.3828C87.9834 91.3828 87.4281 91.2988 86.9428 91.1308C86.4574 90.9721 86.0794 90.7248 85.8088 90.3888C85.5381 90.0621 85.4028 89.6468 85.4028 89.1428C85.4028 88.8814 85.4728 88.5968 85.6128 88.2888C85.7528 87.9901 86.0141 87.7054 86.3968 87.4348C86.1914 87.3508 86.0141 87.2621 85.8648 87.1688C85.7248 87.0661 85.5941 86.9541 85.4728 86.8328V86.5108L86.6628 85.3348C86.1121 84.8681 85.8368 84.2521 85.8368 83.4868C85.8368 83.0294 85.9441 82.6141 86.1588 82.2408C86.3734 81.8674 86.6861 81.5734 87.0968 81.3588C87.5074 81.1348 88.0068 81.0228 88.5948 81.0228C88.9961 81.0228 89.3601 81.0788 89.6868 81.1908H92.2488V82.0728L90.9468 82.1288C91.2174 82.5208 91.3528 82.9734 91.3528 83.4868C91.3528 83.9441 91.2408 84.3594 91.0168 84.7328C90.8021 85.1061 90.4894 85.4048 90.0788 85.6288C89.6774 85.8434 89.1828 85.9508 88.5948 85.9508ZM88.5948 84.9848C89.0894 84.9848 89.4814 84.8588 89.7708 84.6068C90.0694 84.3454 90.2188 83.9721 90.2188 83.4868C90.2188 83.0108 90.0694 82.6468 89.7708 82.3948C89.4814 82.1334 89.0894 82.0028 88.5948 82.0028C88.0908 82.0028 87.6894 82.1334 87.3908 82.3948C87.1014 82.6468 86.9568 83.0108 86.9568 83.4868C86.9568 83.9721 87.1014 84.3454 87.3908 84.6068C87.6894 84.8588 88.0908 84.9848 88.5948 84.9848ZM86.5508 89.0308C86.5508 89.4974 86.7468 89.8428 87.1388 90.0668C87.5308 90.3001 88.0208 90.4168 88.6088 90.4168C89.1874 90.4168 89.6494 90.2908 89.9948 90.0388C90.3494 89.7868 90.5268 89.4508 90.5268 89.0308C90.5268 88.7321 90.4054 88.4708 90.1628 88.2468C89.9201 88.0321 89.4721 87.9061 88.8188 87.8688C88.3054 87.8314 87.8621 87.7848 87.4888 87.7288C87.1061 87.9341 86.8541 88.1534 86.7328 88.3868C86.6114 88.6294 86.5508 88.8441 86.5508 89.0308ZM96.4239 88.3028C95.7613 88.3028 95.1733 88.1534 94.6599 87.8548C94.1466 87.5468 93.7406 87.1221 93.4419 86.5808C93.1526 86.0394 93.0079 85.4001 93.0079 84.6628C93.0079 83.9348 93.1526 83.3001 93.4419 82.7588C93.7313 82.2081 94.1326 81.7834 94.6459 81.4848C95.1686 81.1768 95.7706 81.0228 96.4519 81.0228C97.1239 81.0228 97.7026 81.1768 98.1879 81.4848C98.6826 81.7834 99.0606 82.1801 99.3219 82.6748C99.5833 83.1694 99.7139 83.7014 99.7139 84.2708C99.7139 84.3734 99.7093 84.4761 99.6999 84.5788C99.6999 84.6814 99.6999 84.7981 99.6999 84.9288H94.1699C94.1979 85.4608 94.3193 85.9041 94.5339 86.2588C94.7579 86.6041 95.0333 86.8654 95.3599 87.0428C95.6959 87.2201 96.0506 87.3088 96.4239 87.3088C96.9093 87.3088 97.3153 87.1968 97.6419 86.9728C97.9686 86.7488 98.2066 86.4454 98.3559 86.0628H99.5179C99.3313 86.7068 98.9719 87.2434 98.4399 87.6728C97.9173 88.0928 97.2453 88.3028 96.4239 88.3028ZM96.4239 82.0168C95.8639 82.0168 95.3646 82.1894 94.9259 82.5348C94.4966 82.8708 94.2493 83.3654 94.1839 84.0188H98.5519C98.5239 83.3934 98.3093 82.9034 97.9079 82.5488C97.5066 82.1941 97.0119 82.0168 96.4239 82.0168Z"
                fill="#080816"
                fill-opacity="0.38"
              />
              <g clip-path="url(#clip0_1092_103139)">
                <path
                  d="M67.2432 56.7618C67.4986 56.7618 67.7482 56.686 67.9605 56.5441C68.1728 56.4022 68.3382 56.2006 68.4359 55.9647C68.5336 55.7288 68.5592 55.4692 68.5094 55.2188C68.4596 54.9683 68.3367 54.7383 68.1561 54.5577L60.1867 46.5895C58.976 45.3792 57.3341 44.6992 55.6222 44.6992C53.9102 44.6992 52.2684 45.3792 51.0576 46.5895L48.2531 49.3928C48.0179 49.6363 47.8877 49.9625 47.8907 50.301C47.8936 50.6396 48.0294 50.9634 48.2688 51.2028C48.5082 51.4422 48.8321 51.578 49.1706 51.581C49.5092 51.5839 49.8354 51.4538 50.0789 51.2186L52.8834 48.4153C53.621 47.7105 54.602 47.3171 55.6222 47.3171C56.6424 47.3171 57.6233 47.7105 58.3609 48.4153L66.3303 56.3835C66.5724 56.6257 66.9008 56.7618 67.2432 56.7618Z"
                  fill="#080816"
                  fill-opacity="0.38"
                />
                <path
                  d="M64.6599 45.7867C65.5538 45.7867 66.4275 45.5216 67.1707 45.025C67.9139 44.5284 68.4932 43.8226 68.8352 42.9968C69.1773 42.171 69.2668 41.2624 69.0924 40.3857C68.918 39.509 68.4876 38.7038 67.8556 38.0717C67.2235 37.4397 66.4183 37.0093 65.5416 36.8349C64.665 36.6605 63.7563 36.75 62.9305 37.0921C62.1047 37.4341 61.3989 38.0134 60.9023 38.7566C60.4057 39.4998 60.1406 40.3735 60.1406 41.2674C60.1406 42.466 60.6168 43.6155 61.4643 44.463C62.3118 45.3105 63.4613 45.7867 64.6599 45.7867V45.7867ZM64.6599 39.3305C65.043 39.3305 65.4175 39.4441 65.736 39.6569C66.0545 39.8698 66.3028 40.1723 66.4494 40.5262C66.5959 40.8801 66.6343 41.2695 66.5596 41.6452C66.4848 42.0209 66.3004 42.366 66.0295 42.6369C65.7586 42.9078 65.4135 43.0923 65.0378 43.167C64.6621 43.2417 64.2727 43.2034 63.9187 43.0568C63.5648 42.9102 63.2623 42.6619 63.0495 42.3434C62.8367 42.0249 62.7231 41.6504 62.7231 41.2674C62.7231 40.7537 62.9271 40.261 63.2904 39.8978C63.6536 39.5346 64.1463 39.3305 64.6599 39.3305V39.3305Z"
                  fill="#080816"
                  fill-opacity="0.38"
                />
                <path
                  d="M73.6988 52.8887C73.3563 52.8887 73.0279 53.0247 72.7857 53.2669C72.5436 53.509 72.4076 53.8374 72.4076 54.1799V56.7624C72.4076 57.7897 71.9994 58.775 71.273 59.5015C70.5465 60.2279 69.5612 60.6361 68.5339 60.6361H65.9514C65.6089 60.6361 65.2805 60.7721 65.0383 61.0143C64.7962 61.2564 64.6602 61.5848 64.6602 61.9273C64.6602 62.2698 64.7962 62.5982 65.0383 62.8403C65.2805 63.0825 65.6089 63.2185 65.9514 63.2185H68.5339C70.2455 63.2165 71.8865 62.5356 73.0968 61.3253C74.3071 60.115 74.988 58.474 74.99 56.7624V54.1799C74.99 53.8374 74.854 53.509 74.6118 53.2669C74.3697 53.0247 74.0412 52.8887 73.6988 52.8887Z"
                  fill="#080816"
                  fill-opacity="0.38"
                />
                <path
                  d="M45.2912 42.5584C45.6337 42.5584 45.9621 42.4223 46.2043 42.1802C46.4464 41.938 46.5825 41.6096 46.5825 41.2671V38.6847C46.5825 37.6573 46.9906 36.672 47.717 35.9456C48.4435 35.2191 49.4288 34.811 50.4562 34.811H53.0386C53.3811 34.811 53.7095 34.6749 53.9517 34.4328C54.1938 34.1906 54.3299 33.8622 54.3299 33.5197C54.3299 33.1773 54.1938 32.8489 53.9517 32.6067C53.7095 32.3646 53.3811 32.2285 53.0386 32.2285H50.4562C48.7445 32.2306 47.1036 32.9114 45.8932 34.1217C44.6829 35.3321 44.0021 36.973 44 38.6847V41.2671C44 41.6096 44.136 41.938 44.3782 42.1802C44.6203 42.4223 44.9488 42.5584 45.2912 42.5584Z"
                  fill="#080816"
                  fill-opacity="0.38"
                />
                <path
                  d="M53.0386 60.6361H50.4562C49.4288 60.6361 48.4435 60.2279 47.717 59.5015C46.9906 58.775 46.5825 57.7897 46.5825 56.7624V54.1799C46.5825 53.8374 46.4464 53.509 46.2043 53.2669C45.9621 53.0247 45.6337 52.8887 45.2912 52.8887C44.9488 52.8887 44.6203 53.0247 44.3782 53.2669C44.136 53.509 44 53.8374 44 54.1799V56.7624C44.0021 58.474 44.6829 60.115 45.8932 61.3253C47.1036 62.5356 48.7445 63.2165 50.4562 63.2185H53.0386C53.3811 63.2185 53.7095 63.0825 53.9517 62.8403C54.1938 62.5982 54.3299 62.2698 54.3299 61.9273C54.3299 61.5848 54.1938 61.2564 53.9517 61.0143C53.7095 60.7721 53.3811 60.6361 53.0386 60.6361Z"
                  fill="#080816"
                  fill-opacity="0.38"
                />
                <path
                  d="M68.5339 32.2285H65.9514C65.6089 32.2285 65.2805 32.3646 65.0383 32.6067C64.7962 32.8489 64.6602 33.1773 64.6602 33.5197C64.6602 33.8622 64.7962 34.1906 65.0383 34.4328C65.2805 34.6749 65.6089 34.811 65.9514 34.811H68.5339C69.5612 34.811 70.5465 35.2191 71.273 35.9456C71.9994 36.672 72.4076 37.6573 72.4076 38.6847V41.2671C72.4076 41.6096 72.5436 41.938 72.7857 42.1802C73.0279 42.4223 73.3563 42.5584 73.6988 42.5584C74.0412 42.5584 74.3697 42.4223 74.6118 42.1802C74.854 41.938 74.99 41.6096 74.99 41.2671V38.6847C74.988 36.973 74.3071 35.3321 73.0968 34.1217C71.8865 32.9114 70.2455 32.2306 68.5339 32.2285V32.2285Z"
                  fill="#080816"
                  fill-opacity="0.38"
                />
              </g>
              <defs>
                <clipPath id="clip0_1092_103139">
                  <rect
                    width="30.9896"
                    height="30.9896"
                    fill="white"
                    transform="translate(44 32.2285)"
                  />
                </clipPath>
              </defs>
            </svg>
          </vue-dropzone> -->
        </v-card>

        <v-container class="mt-4">
          <v-text-field
            v-model="firstname"
            :counter="10"
            label="First name"
            required
            class="lable-text"
          ></v-text-field>
          <v-text-field
            v-model="lastname"
            :counter="10"
            label="Last name"
            required
          ></v-text-field>

          <v-textarea v-model="shortdescription" :counter="300">
            <template v-slot:label>
              <div>Short description</div>
            </template>
          </v-textarea>
          <template>
            <div class="h5 mb-5">Location</div>

            <v-card color="white" flat>
              <v-col cols="12">
                <v-text-field
                  flat
                  background-color="#F6F8FC"
                  label="Location"
                  solo
                  class="feild mt-2"
                ></v-text-field>
                <v-text-field
                  flat
                  background-color="#F6F8FC"
                  label="Contact number"
                  solo
                  class="feild mt-5"
                ></v-text-field>

                <div class="d-flex justify-end">
                  <v-btn
                    color="red"
                    text
                    class="text_style"
                    @click="deleteRow(index)"
                  >
                    Delete
                  </v-btn>
                </div>
              </v-col>
            </v-card>
            <v-card color="white" flat class="mt-5">
              <v-col cols="12">
                <v-text-field
                  flat
                  background-color="#F6F8FC"
                  label="Location"
                  solo
                  class="feild mt-2"
                ></v-text-field>
                <v-text-field
                  flat
                  background-color="#F6F8FC"
                  label="Contact number"
                  solo
                  class="feild mt-5"
                ></v-text-field>

                <div class="d-flex justify-end">
                  <v-btn
                    color="red"
                    text
                    class="text_style"
                    @click="deleteRow(index)"
                  >
                    Delete
                  </v-btn>
                </div>
              </v-col>
            </v-card>
            <div
              v-for="(div, index) in divs"
              :key="div.id"
              :div="(div = index)"
            >
              <v-card color="white" flat class="mt-5">
                <v-col cols="12">
                  <v-text-field
                    flat
                    background-color="#F6F8FC"
                    label="Location"
                    solo
                    class="feild mt-2"
                  ></v-text-field>
                  <v-text-field
                    flat
                    background-color="#F6F8FC"
                    label="Contact number"
                    solo
                    class="feild mt-5"
                  ></v-text-field>

                  <div class="d-flex justify-end">
                    <v-btn
                      color="red"
                      text
                      @click="deleteRow(index)"
                      class="text_style"
                    >
                      Delete
                    </v-btn>
                  </div>
                </v-col>
              </v-card>
            </div>

            <div class="d-flex justify-end">
              <template>
                <v-btn text darkss class="index_h5" @click="addRow">
                  Add Location
                </v-btn>
              </template>
            </div>
          </template>
          <v-textarea v-model="biography">
            <template v-slot:label>
              <div>Biography</div>
            </template>
          </v-textarea>
        </v-container>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import PractitionerimageuploaderComponent from "./practitionerimageuploader.component.vue";

export default {
  name: "editcomponent",
  components: {
    PractitionerimageuploaderComponent,
  },
  data() {
    return {
      div: 0,
      divs: [],
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 200,
        addRemoveLinks: true,
      },
      valid: false,
      firstname: "",
      lastname: "",
      shortdescription: "",
      biography: "",
    };
  },
  methods: {
    addRow() {
      this.divs.push({
        div: this.div,
      });
    },
    deleteRow(index) {
      this.divs.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.vue-dropzone {
  padding: 0;
  background: transparent;
  border-style: dashed;
  border-radius: 50%;
}

.feild {
  background-color: #f6f8fc;
  border: 1px solid #dee3ef;
  border-radius: 6px;
  height: 50px;
}
.lable-text {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #222222;
}
.index_h5 {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  text-transform: none;

  color: #0071bd;
}
</style>
